import "../index";
import { Collapse } from "bootstrap";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { doc, collection, updateDoc, getDoc, getFirestore, setDoc, deleteDoc } from "firebase/firestore";
import confetti from 'canvas-confetti';
import { marked } from "marked";
import xss from "xss";

const auth = getAuth();
const db = getFirestore();

var userUID;
var userData;
var teamUID;
var teamNo;

var membersDataFB;
var membersData = [];
var pendingMembersData = [];

document.addEventListener("DOMContentLoaded", function (event) {
    setSpinner("avatar");
    const showNavbar = (toggleId, navId, bodyId, headerId) => {
        const toggle = document.getElementById(toggleId),
            nav = document.getElementById(navId),
            bodypd = document.getElementById(bodyId),
            headerpd = document.getElementById(headerId)

        // Validate that all variables exist
        if (toggle && nav && bodypd && headerpd) {
            toggle.addEventListener('click', () => {
                // show navbar
                nav.classList.toggle('showSB')
                // change icon
                toggle.classList.toggle('bx-x')
                // add padding to body
                bodypd.classList.toggle('body-pd')
                // add padding to header
                headerpd.classList.toggle('body-pd')
            })
        }
    }

    showNavbar('header-toggle', 'nav-bar', 'body-pd', 'header')

    /*===== LINK ACTIVE =====*/
    const linkColor = document.querySelectorAll('.nav_link')

    function colorLink() {
        if (linkColor) {
            linkColor.forEach(l => l.classList.remove('active'))
            this.classList.add('active')
        }
    }
    linkColor.forEach(l => l.addEventListener('click', colorLink))

    // Announcement

    fetch("https://data.vhackusm.com/announcement.json")
        .then(response => response.json())
        .then(data => {
            data.forEach(data => {
                document.getElementById("announcement-list").innerHTML += `
                <li class="list-group-item list-group-item-${data.type} d-flex flex-wrap flex-sm-nowrap justify-content-between align-items-center gap-2">
                    <div id="letter-notification">
                        ${data.notification}
                    </div>
                    <span class="badge bg-primary rounded-pill time-ago">${data.time}</span>
                </li>`
            });

            document.querySelectorAll(".time-ago").forEach((e) => {
                const innerTS = e.innerHTML;
                e.innerHTML = timeSince(new Date(parseInt(innerTS))) + " ago";
            });
        });


    // Header hide scroll
    var prevScrollpos = window.pageYOffset;
    window.onscroll = function() {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
            document.getElementById("header").style.top = "0";
        } else if (currentScrollPos > 50) {
            document.getElementById("header").style.top = "-64px";
        }
        prevScrollpos = currentScrollPos;
    }

    const caseStudySubmit = document.querySelector("#casestudy-submit");

    // Load user data
    var unsub = onAuthStateChanged(auth, (user) => {
        unsub();
        if (!user) {
            setUserAlert(`You are not logged in! Login <a href="/signin.html">here</a>.`, true);
        } else {
            userUID = user.uid;
            if (!user.emailVerified) {
                setUserAlert(`The registration is closed! You cannot join the competition because you haven't verify your email address. We hope to see you next time!`, true);
            } else {
                getUserData().then((retUserData) => {
                    userData = retUserData;
                    if (userData == undefined) {
                        getDoc(doc(db, "judges", userUID)).then(data => {
                            if (data.exists()) {
                                setUserAlert("Redirecting you to judge dashboard...", true);
                                window.location.href = "/judge/dashboard.html";
                            } else {
                                setUserAlert(`The registration is closed! You cannot join the competition because you haven't filled out the registration form. We hope to see you next time!`, true);
                            }
                        })
                    } else {
                        // Load user info to settings
                        document.querySelector("#fname").textContent = userData.name;
                        document.querySelector("#uemail").textContent = user.email;
                        document.querySelector("#uic").textContent = userData.user_id;
                        document.querySelector("#dsname").textContent = userData.discord_id;
                        document.querySelector("#phoneno").textContent = "+" + userData.phone_no;
                        document.querySelector("#useruni").textContent = userData.university;
                        if (userData.resume) document.querySelector("#inputResume").value = userData.resume;
                        if (userData.university === "Universiti Sains Malaysia (USM)") {
                            document.getElementById("usm").classList.remove("d-none");
                            if (userData.usm) {
                                document.querySelector("#inputUSM").value = userData.usm;
                            }

                            // USM submit event listener
                            let submitUSMbtn = document.querySelector("#submit-usm");
                            submitUSMbtn.addEventListener("click", () => {
                                let inputUSM = document.querySelector("#inputUSM").value;

                                if (inputUSM === userData.usm) {
                                    alert("You are submitting the same thing!");
                                } else {
                                    setSpinner("submit-usm", "text-primary");
                                    updateDoc(doc(db, "users", userUID), {
                                        usm: parseInt(inputUSM)
                                    }).then(() => {
                                        userData.usm = inputUSM;
                                        submitUSMbtn.innerHTML = "Success!";
                                        submitUSMbtn.classList.remove("btn-outline-primary");
                                        submitUSMbtn.classList.add("btn-success");

                                        setTimeout(() => {
                                            submitUSMbtn.innerHTML = "Submit";
                                            submitUSMbtn.classList.add("btn-outline-primary");
                                            submitUSMbtn.classList.remove("btn-success");
                                        }, 5000);
                                    }).catch(e => {
                                        setUserAlert(`Something went wrong, please verify your team code and try again. 
                                        If it is correct, please reload and try again. You may contact admin@vhackusm.com with your account info and the following message: 
                                        <span class="text-muted small">CODEJOIN: ${err.message} ${userUID}</span>`);
                                        submitUSMbtn.innerHTML = "Submit";
                                    })
                                }
                            });
                        }

                        // Get current event data
                        fetch("https://data.vhackusm.com/event-data.json", {cache: "no-store"})
                            .then(res => res.json())
                            .then(data => {
                                if (data.event_name !== "-") {
                                    var atnCollapse = new Collapse(document.getElementById('ongoing-session'), {
                                        toggle: false
                                    })
                                    atnCollapse.show();

                                    document.getElementById("current-session").textContent = data.event_name;
                                    if (data.event_url) {
                                        document.getElementById("session-link").href = data.event_url;
                                        document.getElementById("session-link").classList.remove("d-none");
                                    }

                                    var atncmCollapse = new Collapse(document.getElementById('attendance-checkmark'), {
                                        toggle: false
                                    });
                                    atncmCollapse.hide();

                                    const attendanceButton = document.getElementById("submit-attendance");
                                    const feedbackButton = document.getElementById("feedback");
                                    
                                    if (data.feedback_url) {
                                        feedbackButton.classList.remove("d-none");
                                        feedbackButton.onclick = () => window.open(data.feedback_url,'_blank');
                                    }
                                    if (data.attendance_url) {
                                        attendanceButton.onclick = () => window.open(data.attendance_url,'_blank');
                                    } else if (data.event_no && data.attendance_opened === true) {
                                        // Check if attendance is signed
                                        const attendanceKey = `attendance${data.event_no}`;
                                        if (userData[attendanceKey]) {
                                            setTimeout(() => {
                                                atncmCollapse.show();
                                            }, 500);
                                            attendanceButton.disabled = true;
                                        } else {
                                            // Attendance
                                            attendanceButton.addEventListener("click", () => {
                                                const loading = setSpinner("submit-attendance", "primary");
                                                attendanceButton.disabled = true;
                                                
                                                updateDoc(doc(db, "users", userUID), { [attendanceKey] : new Date() }).then(() => {
                                                    atncmCollapse.show();
                                                    loading();
                                                }).catch(err => {
                                                    if (err.code === "permission-denied") {
                                                        setUserAlert("Attendance cannot be recorded. This might be because the attendance hasn't opened yet or the cut-off time has already been reached.");
                                                        loading(true);
                                                    } else {
                                                        errorShow("ATNSUBMIT", err);
                                                        loading(true);
                                                    }
                                                });
                                            }, { once: true });
                                        }
                                    } else if (data.event_no && data.attendance_opened === false) {
                                        attendanceButton.disabled = true;
                                        attendanceButton.innerText = "Attendance closed";
                                        
                                        // Check if attendance is signed
                                        const attendanceKey = `attendance${data.event_no}`;
                                        if (userData[attendanceKey]) {
                                            setTimeout(() => {
                                                atncmCollapse.show();
                                            }, 500);
                                        }
                                    } else {
                                        attendanceButton.classList.add("d-none");
                                    }
                                }
                            });

                        // Resume submit event listener
                        let submitResumeButton = document.querySelector("#submit-resume");
                        submitResumeButton.addEventListener("click", () => {
                            let inputResume = document.querySelector("#inputResume").value;

                            if (inputResume === userData.resume) {
                                alert("You are submitting the same link!");
                            } else {
                                setSpinner("submit-resume", "text-primary");
                                setUserResume(inputResume).then(() => {
                                    userData.resume = inputResume;
                                    submitResumeButton.innerHTML = "Success!";
                                    submitResumeButton.classList.remove("btn-outline-primary");
                                    submitResumeButton.classList.add("btn-success");

                                    setTimeout(() => {
                                        submitResumeButton.innerHTML = "Submit";
                                        submitResumeButton.classList.add("btn-outline-primary");
                                        submitResumeButton.classList.remove("btn-success");
                                    }, 5000);
                                }).catch(err => {
                                    errorShow("CODEJOIN", err);
                                    submitResumeButton.innerHTML = "Submit";
                                })
                            }
                        });

                        // User notification text
                        if (userData.user_notification) {
                            setAlert("user-notification", userData.user_notification_type, userData.user_notification);
                        }

                        // If user have a team, load all members info
                        if (userData.team) {
                            teamUID = userData.team;

                            loadMemberData().then(e => {
                                membersDataFB = e;

                                // University
                                document.querySelector("#uni").innerHTML = `Team's University: ${e.team_university}`;
                                if (e.team_no) {
                                    teamNo = e.team_no;
                                    document.querySelector("#teamcode").innerHTML = `Team's Number: ${teamNo}`;
                                } else {
                                    document.querySelector("#teamcode").innerHTML = `Team's Number: Unassigned, check back later!`;
                                }

                                // Notification text
                                if (e.team_notification) {
                                    setAlert("team-notification", e.team_notification_type, e.team_notification);
                                }

                                // Load all members, leader as the first
                                var uid = e.members[0];
                                var leader = {
                                    email: e.members_email[uid],
                                    name: e.members_name[uid]
                                };

                                for (var i=1; i<e.members.length; i++) {
                                    uid = e.members[i];
                                    membersData.push({
                                        uid: uid,
                                        email: e.members_email[uid],
                                        name: e.members_name[uid]
                                    });
                                }

                                // Feedback from Judges
                                let totalJudge = 0;
                                const feedbackAccordion = document.getElementById("accordionFeedback");
                                
                                if (!e.technical_eval && !e.business_eval && !e.both_eval) {
                                    feedbackAccordion.innerHTML = `<div class="text-center text-muted">No feedback available.</div>`;
                                } else {
                                    let allJudges = [...e.technical_eval || [], ...e.business_eval || [], ...e.both_eval || []];

                                    console.log(allJudges);

                                    allJudges.forEach(cmt => {
                                        totalJudge += 1;
                                        feedbackAccordion.innerHTML += returnAccItemFeedback(totalJudge, cmt);
                                    })
                                }

                                // Awards
                                if (e.winner) {
                                    document.getElementById("winner").classList.remove("d-none");
                                    document.getElementById("winner-text").textContent = e.winner;

                                    if (localStorage.getItem("winner") !== "true") {
                                        localStorage.setItem("winner", "true");
                                        realisticConfetti();
                                    }

                                    document.getElementById("i-winner").addEventListener("mouseover", () => realisticConfetti());
                                } else if (e.top_15) {
                                    document.getElementById("top-15").classList.remove("d-none");

                                    if (localStorage.getItem("top-15") !== "true") {
                                        localStorage.setItem("top-15", "true");
                                        confetti();
                                    }

                                    document.getElementById("i-top-15").addEventListener("mouseover", () => confetti());
                                }
                                

                                setSubmissionData(e);
                                loadMemeberList(leader, membersData);
                                setAvatar(userData.name);

                            }).catch(err => {
                                if (err.code === "permission-denied" && userData.team) {
                                    setUserAlert(`You seems to have been removed from the team. Reloading the page in 5 seconds...`, false);
                                    memberRemoved().then(() => {
                                        setTimeout(function(){window.location.href="/dashboard.html"}, 5000);
                                    });
                                } else {
                                    errorShow("MEMBERREMOVED", err, true);
                                }
                            });
                        }
                        collapseShow("team-info");

                        if (userData.team_pending !== "" && userData.team_pending !== undefined) {
                            // Pending team
                            document.querySelector("#input-team").classList.remove("d-none");
                            teamUID = userData.team_pending;

                            let inputTeamCode = document.querySelector("#inputTeamCode");
                            inputTeamCode.value = teamUID;
                            inputTeamCode.disabled = true;

                            let submitButton = document.querySelector("#submit-pending");
                            submitButton.disabled = true;
                            submitButton.innerHTML = `<span class="small">Pending Accept</span>`;
                            submitButton.classList.remove("btn-primary");
                            submitButton.classList.add("btn-secondary");

                            document.querySelector("#rl-rm-pending").classList.remove("d-none");

                            setAvatar(userData.name);
                        } else if (userData.leader) {
                            // If user is a leader with no team
                            document.querySelector("#members-list").innerHTML = returnLeader(userData.name, userData.email);
                            
                            if (userData.team == undefined || userData.team == "") {
                                var teamData = {
                                    members: [userUID],
                                    team_leader: userUID,
                                    members_email: {
                                        [userUID]: userData.email
                                    },
                                    members_name: {
                                        [userUID]: userData.name
                                    },
                                    team_university: userData.university,
                                    total_members: 1
                                };

                                addNewTeam(teamData).then((teamRef) => {
                                    
                                    teamUID = teamRef.id;
                                    teamData.team_uuid = teamUID;
                            
                                    fetch(`/api/new-team`, {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify(teamData)
                                    }).catch(err => console.log(err));

                                    userData.team = teamUID;
                                    setAvatar(userData.name);

                                    writeUserTeam().catch((e) => {
                                        setUserAlert(`Unknown error! ${e.message}`);
                                    });
                                })
                                .catch((e) => {
                                    setUserAlert(`Unknown error! ${e.message}`);
                                });
                            }
                        } else if (!userData.team) {
                            setUserAlert("You don't seem to have a team! Unfortunately the registration period is closed. We hope to see you next time!");
                            setAvatar(userData.name);
                        }
                    }
                }).catch((err) => {
                    errorShow("GETUSER", err);
                });
            }

        }
    });

    const projName = document.querySelector("#project-name");
    const caseStudy = document.querySelector("#casestudy");
    const tagline = document.querySelector("#tagline");
    const youtube = document.querySelector("#youtube");
    const figma = document.querySelector("#figma");
    const desc = document.querySelector("#desc");
    const lastSubmit = document.querySelector("#submitted-time");

    function setSubmissionData(obj) {
        if (obj.project_name) projName.value = obj.project_name;
        if (obj.case_study) caseStudy.value = obj.case_study;
        if (obj.tagline) tagline.value = obj.tagline;
        if (obj.yt_url) youtube.value = obj.yt_url;
        if (obj.figma_url) figma.value = obj.figma_url;
        if (obj.description) desc.value = obj.description;
        if (obj.last_submitted) lastSubmit.textContent = `(${new Date(obj.last_submitted.seconds*1000).toLocaleString("en-MY",{timeZoneName: "long"})})`;
    }

    async function loadMemberData() {
        const docRef = doc(db, "teams", teamUID);
        const docSnap = await getDoc(docRef);

        return docSnap.data();
    }

    function returnLeader(name = "", email = "") {
        return `<li class="list-group-item d-flex justify-content-between align-items-center gap-3">
        <span><i class='bx bxs-user-voice fs-5 align-middle' title="Team Leader">
        </i> <span id="team-leader-name">${name}</span> — 
        <span class="text-muted" id="team-leader-email">${email}</span></span></li>`
    }

    function returnMember(uid = "", name = "", email = "") {
        return `<li class="list-group-item d-flex justify-content-between align-items-center gap-3">
        <span><span class="member-name">${name}</span> — <span class="text-muted" class="member-email">${email}</span></span></li>`;
    }

    function returnPendingMember(uid = "", name = "", email = "") {
        return `<li class="list-group-item list-group-item-warning d-flex justify-content-between align-items-center gap-3">
        <span><span class="member-pending-name">${name}</span> — <span class="text-muted" class="member-pending-email">${email}</span></span><span class="pending-button">
            <button class="btn btn-sm btn-success" title="Accept member" id="${uid}-accept"><i class='bx bx-check fs-5 align-middle'></i></button>
            <button class="btn btn-sm btn-danger" title="Decline member" id="${uid}-decline"><i class='bx bx-x fs-5 align-middle'></i></button></span></li>`;
    }

    function loadMemeberList(leader, membersList, pendingMemberList = []) {
        var membersListEle = document.querySelector("#members-list");
        
        membersListEle.innerHTML = returnLeader(leader.name, leader.email);

        var appendList = "";
        for (var i=0; i<membersList.length; i++) {
            appendList += returnMember(i, membersList[i].name, membersList[i].email);
        }
        
        for (var i=0; i<pendingMemberList.length; i++) {
            appendList += returnPendingMember(i, pendingMemberList[i].name, pendingMemberList[i].email);
        }


        appendHTML(membersListEle, appendList);
        linkMemberList();
    }

    // Leader function on member
    function linkMemberList() {
        document.querySelectorAll(".list-group-item").forEach(box => {
            box.querySelectorAll(".btn").forEach(button => {
                button.addEventListener("click", (e) => {

                    let eleId = e.target.id;
                    if (!eleId) eleId = e.path[1].id;

                    let id = eleId.split("-")[0];
                    let code = eleId.split("-")[1];

                    switch(code) {
                        // Pending members
                        case "accept":
                            if (membersData.length >= 4) {
                                setUserAlert("You have exceeded the maximum number of members in your team!");
                                setTimeout(
                                    function () {
                                        setUserAlert();
                                    }, 5000);
                                break;
                            } else if (confirm(`Are you sure to add ${pendingMembersData[id].name} (${pendingMembersData[id].email}) into your team?`)) {
                                let user = pendingMembersData[id];

                                membersDataFB.members.push(user.uid);
                                membersDataFB.members_email[user.uid] = user.email;
                                membersDataFB.members_name[user.uid] = user.name;
                                membersDataFB.total_members += 1

                                pendingMembersData.splice(id,1);

                                writeDirectMembers(membersDataFB).then(removePendingMembers(user.uid).then(reloadMemberList()));
                            }
                            break;
                        case "decline":
                            if (confirm(`Are you sure to reject ${pendingMembersData[id].name} (${pendingMembersData[id].email})?`)) {
                                let user = pendingMembersData[id];
                                pendingMembersData.splice(id,1);
                                removePendingMembers(user.uid).then(reloadMemberList());
                            }
                            break;
                        case "remove":
                            if (confirm(`Are you sure to remove ${membersData[id].name} (${membersData[id].email}) from your team?`)) {
                                let user = membersData[id];

                                membersDataFB.members = membersDataFB.members.filter(item => item !== user.uid);
                                delete membersDataFB.members_email[user.uid];
                                delete membersDataFB.members_name[user.uid];
                                membersDataFB.total_members -= 1

                                writeDirectMembers(membersDataFB).then(reloadMemberList());
                            }
                            break;
                        default:
                            break;
                    }
                })
            })
        })
    }

    function reloadMemberList() {
        membersData = [];
        let e = membersDataFB;
        var uid = e.members[0];
        var leader = {
            email: e.members_email[uid],
            name: e.members_name[uid]
        };

        for (var i=1; i<e.members.length; i++) {
            uid = e.members[i];
            membersData.push({
                uid: uid,
                email: e.members_email[uid],
                name: e.members_name[uid]
            });
        }

        loadMemeberList(leader, membersData, pendingMembersData);
    }

    document.querySelector("#reload-pending").addEventListener("click", () => {
        setSpinner("reload-pending");

        loadMemberData().then(() => {
            confirmJoined().then(() => window.location.reload())
            .catch(err => {
                errorShow("CONFIRMJOINED", err);
            });
        }).catch(() => {
            // Still unverified
            checkIfRejected().then(e => {
                if (e.exists()) {
                    setUserAlert(`Your team leader seems to not have accepted your request yet, please try again later!`, false);
                    document.querySelector("#reload-pending").innerHTML = `<i class='bx bx-revision fs-5 align-top'></i> Reload`;
                } else {
                    // Removed!
                    setUserAlert(`The team leader rejected your request to join the group, reloading the page in 5 seconds...`, false);
                    document.querySelector("#reload-pending").innerHTML = `<i class='bx bx-revision fs-5 align-top'></i> Reload`;
                    removePending().then(() => {
                        setTimeout(function(){window.location.href="/dashboard.html"}, 5000);
                    }).catch(err => {
                        errorShow("CHECKREJECTEDEXISTS", err);
                    });
                }
            }).catch(err => {
                errorShow("CHECKREJECTED", err);
            });
        });
    });

    document.querySelector("#remove-pending").addEventListener("click", () => {
        setSpinner("remove-pending");

        loadMemberData().then(() => {
            confirmJoined().then(() => {
                setUserAlert(`Your team leader seems to have already accepted your request, please ask your leader to remove you from the team. (Reloading in 5 seconds...)`, false);
                document.querySelector("#reload-pending").innerHTML = `<i class='bx bx-revision fs-5 align-top'></i> Reload`;
                setTimeout(function(){window.location.href="/dashboard.html"}, 5000);
            })
            .catch(err => {
                errorShow("CONFIRMJOINEDRP", err);
            });
        }).catch(() => {
            // Still unverified
            removePendingMembers(userUID).then(() => {
                removePending().then(() => {
                    setUserAlert(`Removal complete, reloading the page in 5 seconds...`,false);
                    document.querySelector("#remove-pending").innerHTML = `<i class='bx bx-x fs-5 align-top'></i> Remove`;
                    setTimeout(function(){window.location.href="/dashboard.html"}, 5000);
                }).catch(err => {
                    errorShow("REMOVEPENDING", err);
                });
            }).catch(err => {
                errorShow("REMOVEPENDINGMEM", err);
            });
        });
    });

    document.querySelector("#signout").addEventListener("click", () => {
        document.querySelector("#signout").innerHTML = `<div class="spinner-border text-light spinner-border-sm ms-1" role="status"><span class="visually-hidden">Loading...</span></div>`;
        signOut(auth).then(() => {
            window.location.href = "/index.html";
        }).catch((err) => {
            errorShow("SIGNOUT",err.message);
        });
    });

    function setUserAlert(str = "", resetAvatar = false, scrollToTop = true) {
        let userAlert = document.querySelector("#user-alert");
        if (str !== "") userAlert.innerHTML = `<div class="alert alert-warning alert-dismissible fade show" role="alert">${str} <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></div>`;
        else userAlert.innerHTML = "";
        if (resetAvatar) setAvatar();
        if (str !== "" && scrollToTop) {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }
    }

    function setSuccessAlert(str = "") {
        if (str !== "") document.querySelector("#user-alert").innerHTML = `<div class="alert alert-success" role="alert">${str}</div>`;
        else document.querySelector("#user-alert").innerHTML = "";
    }

    async function getUserData() {
        const docRef = doc(db, "users", userUID);
        const docSnap = await getDoc(docRef);
        return docSnap.data();
    }

    async function addNewTeam(teamData) {
        const newTeamRef = doc(collection(db, "teams"));
        await setDoc(newTeamRef, teamData);
        return newTeamRef;
    }

    async function setUserResume(resume) {
        const userRef = doc(db, "users", userUID);

        await updateDoc(userRef, {
            resume: resume
        });
    }

    // Used while team leader created a new team
    async function writeUserTeam() {
        const userRef = doc(db, "users", userUID);
        await updateDoc(userRef, {
            team: teamUID
        });
    }

    async function writeDirectMembers(obj) {
        const userRef = doc(db, "teams", teamUID);
        await setDoc(userRef, obj);
    }

    async function removePendingMembers(uid) {
        await deleteDoc(doc(db, "teams", teamUID, "pending_members", uid));
    }

    async function removePending() {
        const userRef = doc(db, "users", userUID);

        await updateDoc(userRef, {
            team_pending: ""
        });
    }

    async function checkIfRejected() {
        const teamRef = doc(db, "teams", teamUID, "pending_members", userUID);
        const docSnap = await getDoc(teamRef);

        return docSnap;
    }

    async function confirmJoined() {
        const userRef = doc(db, "users", userUID);

        await updateDoc(userRef, {
            team_pending: "",
            team: teamUID
        });
    }

    async function memberRemoved() {
        const userRef = doc(db, "users", userUID);

        await updateDoc(userRef, {
            team: ""
        });
    }

    function setAlert(htmlID, type, text) {
        document.getElementById(htmlID).innerHTML =
            `<div class="alert alert-${type} alert-dismissible fade show" role="alert">${text}<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" id="${htmlID}-dismiss"></button></div>`;
    }

    function setSubmissionAlert(msg, type = "warning") {
        setAlert("submission-alert", type, msg);
        document.getElementById("submission").scrollIntoView();
    }

    function errorShow(errCode, err, resetAvatar = false) {
        setUserAlert(`Something went wrong, please reload and try again. You may contact admin@vhackusm.com with your account info and the following message: 
                    <span class="text-muted small">${errCode}: ${err.message} ${userUID}</span>`, resetAvatar);
    }

    function setSpinner(tag, col = "text-light") {
        const ele = document.getElementById(tag);
        const inner = ele.innerHTML;
        ele.innerHTML = `<div class="spinner-border ${col} spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>`;
        return function(btnEnable) {
            ele.innerHTML = inner;
            if (btnEnable) ele.disabled = false;
        };
    }

    function successBadge() {
        cmCollapse.show();
        setTimeout(() => {
            cmCollapse.hide();
        }, 3000);
    }

    function setAvatar(name = "") {
        document.querySelector("#avatar").innerHTML = `<i class='bx bxs-user-circle d-none d-sm-block' style="font-size: 2rem;"></i>`;
        document.querySelector("#account-name").innerHTML = name;
        collapseShow('avatar');
        collapseShow('account-name');
    }

    function collapseShow(id) {
        return new Collapse(document.getElementById(id), {
            toggle: false
        }).show();
    }

    function appendHTML(item, appendItem) {
        item.innerHTML = item.innerHTML + appendItem;
    }

    function updateCounter(counterEle, limit, currLength) {
        counterEle.innerHTML = limit - currLength;
    }
});

function timeTrack(date, ele) {
    var timeTrackStr = timeSince(date);
    ele.textContent = timeTrackStr + " ago";

    if (timeTrackStr.includes("second")) {
        return timeTrackSub(date, ele, "minutes", 1, () => timeTrack(data, ele));
    } else if (timeTrackStr.includes("minutes")) {
        return timeTrackSub(date, ele, "hours", 10, () => timeTrack(data, ele));
    } else if (timeTrackStr.includes("hours")) {
        return timeTrackSub(date, ele, "days", 60, () => timeTrack(data, ele));
    }
}

function timeTrackSub(date, ele, text, dt, callback) {
    return setInterval(() => {
        var timeTrackStr = timeSince(date);
        ele.textContent = timeTrackStr + " ago";
        if (timeTrackStr.includes(text)) {
            clearInterval(interval);
            callback();
        }
    }, dt*1000);
}

function timeSince(date) {
    var seconds = Math.floor((new Date() - date) / 1000);
    var interval = seconds / 31536000;
    if (seconds < 0) {
      return "N/A";
    }
    if (interval > 1) {
      return Math.floor(interval) + " years";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes";
    }
    return Math.floor(seconds) + " seconds";
  }

// canvas-confetti
var count = 200;
var defaults = {
  origin: { y: 0.7 }
};

function fire(particleRatio, opts) {
  confetti(Object.assign({}, defaults, opts, {
    particleCount: Math.floor(count * particleRatio)
  }));
}

function realisticConfetti() {
    fire(0.25, {
        spread: 26,
        startVelocity: 55,
      });
      fire(0.2, {
        spread: 60,
      });
      fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8
      });
      fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2
      });
      fire(0.1, {
        spread: 120,
        startVelocity: 45,
      });

}

function returnAccItemFeedback(judgeNo, cmt) {
    return `
    <div class="accordion-item">
        <h2 class="accordion-header" id="h-j-${judgeNo}">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#j-${judgeNo}" aria-expanded="false" aria-controls="j-${judgeNo}">
                Feedback ${judgeNo}
            </button>
        </h2>
        <div id="j-${judgeNo}" class="accordion-collapse collapse" aria-labelledby="h-j-${judgeNo}">
            <div class="accordion-body">
                ${xss(marked.parse(cmt))}
            </div>
        </div>
    </div>
    
    `
}
